import FormDescriptionSection from "./form-description-section/form-description-section";
import useFormSectionHook from "./form-section.hook";
import OptionSelection from "./option-section/option-selection";
import { useCoverForContext } from "../../provider/cover-for.provider";

function CoverForFormSection() {
  const { toggleButtonOptions, handleOptionSelect } = useFormSectionHook();
  const { cmsData } = useCoverForContext();
  const { questionText } = cmsData.overlayArea[0];
  return (
    <div className="w-full flex justify-center">
      <div className="lg:w-[414px] md:w-[400px] w-full ">
        <h1
          className=" font-header-font lg:text-[39px] md:text-3xl text-[26px] lg:leading-[44.85px] 
       md:leading-[34.1px] leading-[29.9px] text-text-title md:text-left text-center"
        >
          {questionText}
        </h1>
        <FormDescriptionSection />
        <OptionSelection
          options={toggleButtonOptions}
          onOptionSelect={(id) => {
            handleOptionSelect(id);
          }}
        />
      </div>
    </div>
  );
}

export default CoverForFormSection;
